import React from 'react'
import { motion } from 'framer-motion'

interface PageTransitionProps {
  children: React.ReactNode
  className?: string
}

const PageTransition: React.FC<PageTransitionProps> = ({ children, className = '' }) => {
  return (
    <div className="relative">
      {/* Page transition overlay - faster animation */}
      <motion.div 
        className="fixed inset-0 bg-gradient-brand z-50 pointer-events-none"
        initial={{ scaleY: 1, transformOrigin: 'top' }}
        animate={{ scaleY: 0 }}
        transition={{ 
          duration: 0.35, 
          ease: [0.4, 0, 0.2, 1] 
        }}
      />
      
      {/* Page content - faster fade in with reduced delay */}
      <motion.div 
        className={className}
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ 
          duration: 0.4, 
          delay: 0.15,
          ease: [0.4, 0, 0.2, 1] 
        }}
      >
        {children}
      </motion.div>
    </div>
  )
}

export default PageTransition